import { render, staticRenderFns } from "./DebtEdit.vue?vue&type=template&id=3987d4cd&"
import script from "./DebtEdit.vue?vue&type=script&lang=js&"
export * from "./DebtEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports